// v2.20 Smart Approval (owner 2026-10-26): the progress line Desain -> Revisi -> ACC customer -> Produksi ->
// Selesai (decided by the server, acc_service.progres) and the customer's version history. The same line for
// the CS and the customer; only the words for "waiting for the approval" differ. No imports, so Jest can test.

// the text under one stage; `untuk` = "customer" (ACC page) or "staf"
export function keterangan(l, untuk = "staf") {
  if (l.keterangan) return l.keterangan;
  if (l.kode === "ACC" && l.status === "JALAN") return untuk === "customer" ? "Menunggu persetujuan Anda" : "Menunggu persetujuan customer";
  if (l.kode === "DESAIN" && l.status === "JALAN") return "Desain sedang dibuat";
  return null;
}

// one line for a small space (a list row): the stage now and its text
export function ringkas(p, untuk = "staf") {
  if (!p) return null;
  if (p.dibatalkan) return "Pesanan dibatalkan";
  const l = (p.langkah || []).find((x) => x.kode === p.tahap);
  if (!l) return null;
  const k = keterangan(l, untuk);
  return k ? `${l.label}: ${k}` : l.label;
}

// what the customer answered on one version (an answer the CS recorded from WhatsApp has no text — owner PASTI)
export function teksJawaban(j) {
  if (j.lewat === "WHATSAPP") return j.status === "REVISI" ? "Revisi diminta lewat WhatsApp" : "Disetujui lewat WhatsApp";
  if (j.status === "DISETUJUI") return "Disetujui";
  return j.catatan ? `Catatan revisi: ${j.catatan}` : "Revisi diminta";
}

export const VERSI_LAMA = "Versi lama — hanya untuk dilihat. Yang bisa disetujui hanya versi terbaru.";
